import type {VoidFunctionComponent} from 'react';
import classnames from 'classnames';

import {FocusRing} from '@react-aria/focus';

import {TypographySize, useTypography} from '../../../hooks/typography';
import {CloseIcon} from '../../../icons/close';

import type {Props} from './types';
import styles from './styles.module.css';

export const Tag: VoidFunctionComponent<Props> = ({id, label, icon, onClose, closable = true}) => {
    const labelTypographyCls = useTypography({
        size: TypographySize.BodyS,
    });
    const handleCloseClick = () => {
        if (onClose) {
            onClose(id);
        }
    };

    return (
        <FocusRing focusRingClass={styles.tagFocused} within={true}>
            <div className={styles.tag}>
                {Boolean(icon) && <span className={styles.tagIcon}>{icon}</span>}
                <span className={classnames(labelTypographyCls, styles.tagLabel)}>{label}</span>
                {closable && (
                    <button type='button' className={styles.tagCloseButton} data-testid='tag-close' onClick={handleCloseClick}>
                        <CloseIcon />
                    </button>
                )}
            </div>
        </FocusRing>
    );
};
